<template>
  <div class="rs-star-rating">
    <div
      v-for="rate in options"
      :key="`rating-${rate.value}`"
      class="d-flex align-items-center"
    >
      <RsFormCheckbox
        :id="`check_${rate.value}`"
        v-model="selectedOptions"
        class="mr-1 mt-1"
        :value="rate.value"
        @change="updateInput()"
      />
      <label class="rs-rating__label">
        <div
          v-for="num in rate.value"
          :key="`star-${num}`"
          class="rs-checkbox-icon"
        >
          <i
            class="fa-lg fas fa-star rs-rating__icon--active"
          />
        </div>
      </label>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ISelectOption } from '@/shared';

export default defineComponent({
  name: 'RsStarRating',
  props: {
    options: {
      type: [] as PropType<Array<ISelectOption>>,
      default: () => [],
    },
    selected: {
      type: [] as PropType<Array<number>>,
      default: () => [],
    },
  },
  data() {
    return {
      selectedOptions: [] as Array<number>,
    };
  },
  watch: {
    selected(): void {
      this.selectedOptions = this.selected;
    },
  },
  mounted() {
    this.selectedOptions = this.selected;
  },
  methods: {
    updateInput(): void {
      this.$emit('change', this.selectedOptions);
    },
  },
});

</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.rs-rating {
  &__label {
      margin-bottom: 2px;
  }
  &__icon--active {
      color: $secondary-color;
      font-size: 13px!important;
  }
}
</style>
